import { SelectListProps } from '@finviz/website/js/main/components/select/select-list'
import * as React from 'react'
import { Link } from 'react-router-dom'

import { ButtonComponentProps, Icon, Select, SelectOption } from '../../components'
import ChartLayout from '../../models/chart_layout'
import { useChartTypes } from './use-chart-types'
import { TypeBaseOption } from './utils'

const isNativeMobileSelect = true // explicitly enable native select for mobile devices

interface Props extends Pick<ButtonComponentProps, 'theme' | 'size'> {
  isPremium: boolean
  model: ChartLayout
  rounding: SelectListProps['rounding']
}
export function ChartTypesSelect({ isPremium, model, ...props }: Props) {
  const { chartTypes, getCurrentType } = useChartTypes({ isPremium, model })
  const currentType = getCurrentType()
  const [selectedType, setSelectedType] = React.useState(currentType)
  const icon = chartTypes.find((item) => item.value === selectedType)?.iconName

  React.useEffect(() => {
    setSelectedType(currentType)
  }, [currentType])

  return (
    <Select
      {...props}
      data-testid="chart-type-select"
      aria-label="Chart type"
      value={selectedType}
      items={chartTypes}
      className="w-[7.25rem]"
      contentClass="truncate"
      listProps={{ rounding: props.rounding }}
      leftContent={
        props.theme === 'chip' ? (
          icon
        ) : (
          <Icon name={chartTypes.find((item) => item.value === selectedType)?.iconName} className="text-gray-300" />
        )
      }
      rightContent={props.theme === 'chip' ? 'caretDown' : undefined}
      hasPopoverButtonWidthLimit={false}
      isNativeMobileSelect={isNativeMobileSelect}
      onChange={(item: TypeBaseOption) => setSelectedType(item.value)}
    >
      {chartTypes.map((item) => {
        const selectOptionProps = item.href
          ? ({ as: Link, to: item.href, reloadDocument: !window.FinvizSettings.hasUserPremium } as ButtonComponentProps<
              typeof Link
            >)
          : ({} as ButtonComponentProps)

        return (
          <SelectOption
            {...selectOptionProps}
            as={selectOptionProps.as}
            data-testid={`chart-type-select-option-${item.value}`}
            key={item.value}
            leftContent={item.iconName}
            rounding={props.rounding}
          >
            {item.label}
          </SelectOption>
        )
      })}
    </Select>
  )
}
